<template>
  <div class="box" id="cardContainer">
    <b class="titleGraph">Recorrência</b>
    <b-tooltip label="Quantidade de usuários conectados de forma recorrente no período de uma semana." type="is-info">
      <i class="fas fa-question-circle"></i>
    </b-tooltip>

    <apexchart
      ref="chart"
      type="bar"
      height="90%"
      width="100%"
      :options="this.options"
      :series="getSeries"
    ></apexchart>

    
  </div>
</template>

<script>
export default {
  name: "apexchartRecurrence",
  props: {
    data: {
      type: Object
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      options: {
        series: [
          {
            name: "Recorrencia por dia",
            data: this.data.totalRecurrence
          }
        ],
        chart: {
          type: "bar",
          stacked: false,
          toolbar: {
            show: true
          }
        },
        colors: ["#f56618"],
        chart: {
          type: "bar",
          stacked: false,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },

        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false,
            dataLabels: {
              position: "center",
              style: {
                colors: ["#000"],
                fontFamily: "arial"
              }
            },
            columnWidth: "70%",
            barHeight: "80%"
          }
        },
        xaxis: {
          categories: this.data.recurrence
        },
        dataLabels: {
          enabled: true,

          style: {
            colors: ["#fff"],
            fontSize: "15px",
            fontFamily: "sans-serif"
          },
          formatter: function(val, opt) {
            return val;
          },

          dropShadow: {
            enabled: true
          }
        },
        yaxis: {
          labels: {
            show: true
          }
        },
        tooltip: {
          enabled: true
        },
        responsive: [
          {
            breakpoint: 1000,
            options: {
              chart: {
                type: "bar",
                stacked: true,
                toolbar: {
                  show: true
                },
                zoom: {
                  enabled: true
                }
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    getSeries() {
      let series = [
        {
          name: "Recorrencia por dia",
          data: this.data.totalRecurrence
        }
      ];

      return series;
    }
  }
};
</script>

<style>
@keyframes rotate {
  to {
    transform: rotate(1turn);
  }
}

#containerChart {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.titleGraph {
  color: #424242;
  font-size: 22px;
  font-family: sans-serif;
}
#cardContainer {
  height: 550px;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ApexChartRecurrence.vue